export default __webpack_public_path__ + "fonts/dnc-icon.svg";